import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { TopActivityCategory } from '@api/methodGroups/crmGroup';
import { rootStore } from '@store/rootStore/instanse';
import { apiRequest } from '@utils/apiRequest';

/**
 * Часто используемые категории деятельности CRM — `GET activity-categories/top`.
 *
 * Топ считается отдельно для товаров, объектов и услуг, поэтому без `type` запрос
 * не уходит: вызывающий передаёт `undefined`, когда список приходит снаружи
 * (например, категории конкретного базового товара) или топ не нужен вовсе.
 */
export const useTopActivityCategories = (
    type?: 'product' | 'object' | 'service'
): TopActivityCategory[] => {
    const [topCategories, setTopCategories] = useState<TopActivityCategory[]>([]);
    const params = useParams();

    useEffect(() => {
        if (!type) return;

        const fetchTopCategories = async () => {
            try {
                const response = await apiRequest(async (api, crmId) => {
                    // crm_id: кука воркера -> параметр маршрута -> первая CRM пользователя
                    // (личный кабинет, где ни куки, ни crm в адресе нет)
                    const routeCrmId = Number(params.crmId ?? params.id);
                    const crm_id =
                        crmId ||
                        (!Number.isNaN(routeCrmId) ? routeCrmId : undefined) ||
                        rootStore.currentUserStore.getUser?.crm_id?.[0];

                    return await api.getCRMCategoriesTop({ crm_id, type });
                });

                setTopCategories(response.data.data || []);
            } catch {
                // топ — подсказка, а не обязательная часть выбора: без него
                // остаётся полный список категорий ниже
            }
        };

        fetchTopCategories();
    }, [type]);

    return topCategories;
};
